import Vue from 'vue'
import App from './App.vue'
import router from './router/'
import store from './store'
import mixins from './mixins'
import openTest from './mixins/console' // 开启console
import {remUnit} from '@/config/config'

import './assets/less/component-style.less';
import Popup from "./components/popup/index"

import './mixins/rem'; // px2rem

Vue.config.productionTip = false;
Vue.prototype.$popup = Popup.install;
Vue.mixin(mixins);

openTest('____', ['test', 'development'].includes(process.env.NODE_ENV), 'change');

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
